import { render, staticRenderFns } from "./LabelField.vue?vue&type=template&id=3d96cab3&scoped=true"
import script from "./LabelField.vue?vue&type=script&lang=ts"
export * from "./LabelField.vue?vue&type=script&lang=ts"
import style0 from "./LabelField.vue?vue&type=style&index=0&id=3d96cab3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d96cab3",
  null
  
)

export default component.exports